<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 d-none d-md-inline-block">
          <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <!-- HTML5 inputs -->
            <div class="card">
              <!-- Card header -->
              <div class="card-header">
                <h3 class="mb-0">Estos campos se reflejarán en la aplicación</h3>
              </div>
              <!-- Card body -->
              <div class="row">
                <div class="col-md-12">
                  <h4 class="mb-0 card-body pb-0">Porcentajes de devolución</h4>
                </div>
                <template v-for="(item, k) in segmentosProductos" :key="item.idParametro">
                  <div class="col-md-3">
                    <div class="card-body form_laive validateClient">
                      <div class="box_loader">
                        <div class="loader"></div>
                      </div>
                      <form @submit.prevent="submitSegmento" :data-key="k">
                        <div class="form-group row">
                          <label class="col-md-12 col-form-label form-control-label">Distribuidora: {{item.nombre}}</label>
                          <div class="col-md-12">
                            <base-input
                              required
                              :name="`${item.idParametro}-segmento`"
                              placeholder="N° de porcentaje"
                              v-model="item.valor"
                              @keypress="isNumber($event)"
                            >
                              <template v-slot:addonLeft>%</template>
                            </base-input>
                            <base-button type="primary" native-type="submit" class="btn-default my-0">Actualizar Segmento</base-button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </template>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="card-body form_laive validateClient">
                    <div class="box_loader">
                      <div class="loader"></div>
                    </div>
                    <form @submit.prevent="submitSemanas">
                      <div class="form-group row">
                        <label class="col-md-12 col-form-label form-control-label">Semana de Ventas</label>
                        <div class="col-md-12">
                          <base-input
                            required
                            name="semana_ventas"
                            v-model="semanas_ventas_prod_refrigerado.valor"
                            placeholder="Semanas de ventas"
                            @keypress="isNumber($event)"
                          >
                            <template v-slot:addonLeft>Sem.</template>
                          </base-input>
                          <base-button type="primary" native-type="submit" class="btn-default my-0">Actualizar Semanas</base-button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from "axios";
  import { useToast } from "vue-toastification";
  import Notification from "@/components/Notification";
  import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
  import { ElSelect, ElOption, ElForm, ElFormItem} from "element-plus";
  import DashboardNavbar from "../Layout/DashboardNavbar";
  export default {
    components: {
      DashboardNavbar,
      RouteBreadCrumb,
      [ElSelect.name]: ElSelect,
      [ElOption.name]: ElOption,
      [ElForm.name]: ElForm,
      [ElFormItem.name]: ElFormItem,
    },
    created(){
      const $this = this;
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      const urlPorcentajes = process.env.VUE_APP_API_URL+"/parametro/lista/porc_devol_prod_refrigerado"
      const getPorcentajes = axios.get(urlPorcentajes,config)
      let urlDistribuidoras = process.env.VUE_APP_API_URL+"/distribuidoras/lista"
      const getDistribuidoras = axios.get(urlDistribuidoras, config);
      const urlSemanasVentas = process.env.VUE_APP_API_URL+"/parametro/lista/semanas_ventas_prod_refrigerado"
      const getSemanasVentas = axios.get(urlSemanasVentas,config)
      axios.all([getPorcentajes, getDistribuidoras, getSemanasVentas]).then(axios.spread((...responses) => {
        const resPorcentajes = responses[0].data
        $this.segmentosProductos = resPorcentajes
        const resDistribuidoras = responses[1].data
        resPorcentajes.forEach((element, i) => {
          let distribuidora = resDistribuidoras.filter((item)=>{return item.idDistribuidora == element.idDistribuidora})
          let nameDist = distribuidora[0].razonSocial
          $this.segmentosProductos[i]["nombre"] = nameDist
        });
        const resSemanas = responses[2].data[0]
        $this.semanas_ventas_prod_refrigerado = resSemanas
        setTimeout(() => {
          const getFormsLaive = document.querySelectorAll(".form_laive")
          getFormsLaive.forEach(element => {
            element.classList.remove("validateClient")
          });
        }, 350);
      })).catch(errors => {
        const getFormsLaive = document.querySelectorAll(".form_laive")
        getFormsLaive.forEach(element => {
          element.classList.remove("validateClient")
        });
      })
    },
    methods: {
      isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
      submitSegmento(evn){
        const keyArray = evn.target.getAttribute("data-key")
        const $parent = evn.target.parentNode
        const token = localStorage.getItem("token")
        const config = {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        };
        const dataSend = this.segmentosProductos[keyArray]
        const urlApiUpdated = process.env.VUE_APP_API_URL+"/parametro/actualizar"
        $parent.classList.add("validateClient")
        axios.put(urlApiUpdated,dataSend,config)
        .then(function (response){
          $parent.classList.remove("validateClient")
          const text =(response.status == 200) ? "Se actualizó el Porcentaje" : "Hubo un error";
          const icon ="ni ni-bell-55";
          const content={
            component: Notification,
            props: {
              icon: icon,
              text: text,
              type: (response.status == 200) ? "success" : "danger",
            },
          };
          const toast = useToast();
          toast(content, {
            hideProgressBar: true,
            icon: false,
            closeButton: false,
            position: "top-right",
          });
        }).catch(function(error){
          console.log({error});
        })
      },
      submitSemanas(evn){
        const $parent = evn.target.parentNode
        const token = localStorage.getItem("token")
        const config = {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        };
        const dataSend = this.semanas_ventas_prod_refrigerado
        const urlApiUpdated = process.env.VUE_APP_API_URL+"/parametro/actualizar"
        $parent.classList.add("validateClient")
        axios.put(urlApiUpdated,dataSend,config)
        .then(function (response){
          $parent.classList.remove("validateClient")
          const text =(response.status == 200) ? "Se actulizaron las semanas" : "Hubo un error";
          const icon ="ni ni-bell-55";
          const content={
            component: Notification,
            props: {
              icon: icon,
              text: text,
              type: (response.status == 200) ? "success" : "danger",
            },
          };
          const toast = useToast();
          toast(content, {
            hideProgressBar: true,
            icon: false,
            closeButton: false,
            position: "top-right",
          });
        }).catch(function(error){
          console.log({error});
        })
      }
    },
    data() {
      return {
        segmentosProductos: [],
        semanas_ventas_prod_refrigerado: {}
      };
    },
  };
</script>

